import { useEffect } from 'react';

export const MESSAGE_SORTIE = 'Des modifications ne sont pas enregistrées. Quitter quand même cette page ?';

// ponytail: liens internes non couverts (useBlocker exige un data router) ; les onglets de langue utilisent confirmerSortie.
export default function useAlerteSortie(hasModifications) {
  useEffect(() => {
    if (!hasModifications) return undefined;
    const avertir = (e) => {
      e.preventDefault();
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', avertir);
    return () => window.removeEventListener('beforeunload', avertir);
  }, [hasModifications]);
}

export const confirmerSortie = (hasModifications) => !hasModifications || window.confirm(MESSAGE_SORTIE);
